module.exports = __webpack_public_path__ + "img/questionnaires.e146238e.svg";